import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const FlaskShape = ({ width = 24, height = 24, style }: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_107_199)">
        <path
          d="M53 106C82.2711 106 106 82.2711 106 53C106 23.7289 82.2711 0 53 0C23.7289 0 0 23.7289 0 53C0 82.2711 23.7289 106 53 106Z"
          fill="#5758BF"
        />
        <path
          d="M63.5165 19.7811H42.5669V41.8158H63.5165V19.7811Z"
          fill="white"
        />
        <path
          d="M63.433 40.2299V19.7811H42.5669V40.2299C32.7181 44.3197 25.707 54.0851 25.707 65.4362C25.707 80.5433 37.8929 92.7292 52.9999 92.7292C68.107 92.7292 80.2929 80.5433 80.2929 65.4362C80.2929 54.0016 73.3653 44.3197 63.433 40.2299Z"
          fill="white"
        />
        <path
          d="M63.5165 19.7811H42.5669V26.1244H63.5165V19.7811Z"
          fill="#E6E9EE"
        />
        <path
          d="M64.0173 23.1197H41.9826C39.2283 23.1197 37.0582 20.9496 37.0582 18.1953C37.0582 15.441 39.2283 13.2709 41.9826 13.2709H64.0173C66.7716 13.2709 68.9417 15.441 68.9417 18.1953C68.9417 20.8661 66.7716 23.1197 64.0173 23.1197Z"
          fill="white"
        />
        <path
          d="M77.2881 65.4362C77.2881 78.7905 66.4377 89.7244 53 89.7244C39.5622 89.7244 28.6283 78.7905 28.6283 65.4362C28.6283 60.9291 29.8803 56.6724 31.9669 53.0834C37.6425 52.0818 44.9039 52.2488 53.8346 55.5874C63.0157 59.0094 70.2771 58.759 75.7858 57.1732C76.7874 59.7606 77.2881 62.5149 77.2881 65.4362Z"
          fill="#9092FB"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_199">
          <rect width="106" height="106" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlaskShape;